// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===========================================
   E2E FULL SCREEN LOADER
=========================================== */

.e2e-loader-wrapper{
    position: fixed;
    inset: 0;
    background: linear-gradient(135deg,#f8fbff,#eef5ff,#ffffff);
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    z-index:99999;
    overflow:hidden;
}

/* Floating background */

.e2e-loader-wrapper::before,
.e2e-loader-wrapper::after{
    content:"";
    position:absolute;
    width:420px;
    height:420px;
    border-radius:50%;
    filter:blur(90px);
    animation:floatBlob 7s infinite ease-in-out;
}

.e2e-loader-wrapper::before{
    background:#4285F455;
    top:-120px;
    left:-120px;
}

.e2e-loader-wrapper::after{
    background:#8E54FF33;
    bottom:-150px;
    right:-150px;
    animation-delay:2s;
}

@keyframes floatBlob{

    0%,100%{
        transform:translate(0,0);
    }

    50%{
        transform:translate(40px,40px);
    }

}

/* ==========================
      LOADER
========================== */

.e2e-loader-spinner{

    width:120px;
    height:120px;
    position:relative;
    display:flex;
    justify-content:center;
    align-items:center;

}

.e2e-loader-spinner::before{

    content:"";
    position:absolute;
    inset:0;
    border-radius:50%;
    padding:5px;

    background:
    linear-gradient(
        135deg,
        #4285F4,
        #5A9BFF,
        #8E54FF,
        #4285F4
    );

    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    mask-composite:exclude;

    animation:rotateRing 1.2s linear infinite;

}

@keyframes rotateRing{

    to{
        transform:rotate(360deg);
    }

}

/* Center */

.circle{

    width:72px;
    height:72px;
    border-radius:50%;
    background:#fff;
    box-shadow:
        0 10px 30px rgba(66,133,244,.18);

    display:flex;
    justify-content:center;
    align-items:center;

    animation:pulseCircle 1.5s infinite;

}

.circle::before{

    content:"E2E";
    color:#4285F4;
    font-size:22px;
    font-weight:700;
    letter-spacing:2px;

}

@keyframes pulseCircle{

    0%,100%{

        transform:scale(1);

    }

    50%{

        transform:scale(.92);

    }

}

/* ==========================
      TEXT
========================== */

.tfm-loader-text{

    margin-top:35px;
    font-size:18px;
    color:#325ea8;
    font-weight:600;
    letter-spacing:.4px;
    position:relative;

}

.tfm-loader-text::after{

    content:"";
    animation:dots 1.4s infinite;

}

@keyframes dots{

    0%{
        content:"";
    }

    25%{
        content:".";
    }

    50%{
        content:"..";
    }

    75%{
        content:"...";
    }

    100%{
        content:"";
    }

}

/* ==========================
      FLOATING PARTICLES
========================== */

.e2e-loader-wrapper span::before,
.e2e-loader-wrapper span::after{

    content:"";
    position:absolute;
    width:10px;
    height:10px;
    border-radius:50%;
    background:#4285F4;

    animation:particle 3s infinite ease-in-out;

}

.e2e-loader-wrapper span::before{

    left:-70px;

}

.e2e-loader-wrapper span::after{

    right:-70px;
    animation-delay:1.2s;

}

@keyframes particle{

    0%{

        transform:
        translateY(0)
        scale(.5);

        opacity:.2;

    }

    50%{

        transform:
        translateY(-30px)
        scale(1);

        opacity:1;

    }

    100%{

        transform:
        translateY(0)
        scale(.5);

        opacity:.2;

    }

}`, "",{"version":3,"sources":["webpack://./src/components/Loader.css"],"names":[],"mappings":"AAAA;;6CAE6C;;AAE7C;IACI,eAAe;IACf,QAAQ;IACR,2DAA2D;IAC3D,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,eAAe;AACnB;;AAEA,wBAAwB;;AAExB;;IAEI,UAAU;IACV,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,2CAA2C;AAC/C;;AAEA;IACI,oBAAoB;IACpB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI;QACI,wBAAwB;IAC5B;;IAEA;QACI,8BAA8B;IAClC;;AAEJ;;AAEA;;4BAE4B;;AAE5B;;IAEI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;;AAEtB;;AAEA;;IAEI,UAAU;IACV,iBAAiB;IACjB,OAAO;IACP,iBAAiB;IACjB,WAAW;;IAEX;;;;;;;KAOC;;IAED;;iCAE6B;IAG7B,sBAAsB;;IAEtB,yCAAyC;;AAE7C;;AAEA;;IAEI;QACI,wBAAwB;IAC5B;;AAEJ;;AAEA,WAAW;;AAEX;;IAEI,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf;wCACoC;;IAEpC,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;;IAElB,mCAAmC;;AAEvC;;AAEA;;IAEI,aAAa;IACb,aAAa;IACb,cAAc;IACd,eAAe;IACf,kBAAkB;;AAEtB;;AAEA;;IAEI;;QAEI,kBAAkB;;IAEtB;;IAEA;;QAEI,oBAAoB;;IAExB;;AAEJ;;AAEA;;4BAE4B;;AAE5B;;IAEI,eAAe;IACf,cAAc;IACd,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,iBAAiB;;AAErB;;AAEA;;IAEI,UAAU;IACV,4BAA4B;;AAEhC;;AAEA;;IAEI;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;IACd;;AAEJ;;AAEA;;4BAE4B;;AAE5B;;;IAGI,UAAU;IACV,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,kBAAkB;;IAElB,0CAA0C;;AAE9C;;AAEA;;IAEI,UAAU;;AAEd;;AAEA;;IAEI,WAAW;IACX,oBAAoB;;AAExB;;AAEA;;IAEI;;QAEI;;iBAES;;QAET,UAAU;;IAEd;;IAEA;;QAEI;;gBAEQ;;QAER,SAAS;;IAEb;;IAEA;;QAEI;;iBAES;;QAET,UAAU;;IAEd;;AAEJ","sourcesContent":["/* ===========================================\r\n   E2E FULL SCREEN LOADER\r\n=========================================== */\r\n\r\n.e2e-loader-wrapper{\r\n    position: fixed;\r\n    inset: 0;\r\n    background: linear-gradient(135deg,#f8fbff,#eef5ff,#ffffff);\r\n    display:flex;\r\n    flex-direction:column;\r\n    justify-content:center;\r\n    align-items:center;\r\n    z-index:99999;\r\n    overflow:hidden;\r\n}\r\n\r\n/* Floating background */\r\n\r\n.e2e-loader-wrapper::before,\r\n.e2e-loader-wrapper::after{\r\n    content:\"\";\r\n    position:absolute;\r\n    width:420px;\r\n    height:420px;\r\n    border-radius:50%;\r\n    filter:blur(90px);\r\n    animation:floatBlob 7s infinite ease-in-out;\r\n}\r\n\r\n.e2e-loader-wrapper::before{\r\n    background:#4285F455;\r\n    top:-120px;\r\n    left:-120px;\r\n}\r\n\r\n.e2e-loader-wrapper::after{\r\n    background:#8E54FF33;\r\n    bottom:-150px;\r\n    right:-150px;\r\n    animation-delay:2s;\r\n}\r\n\r\n@keyframes floatBlob{\r\n\r\n    0%,100%{\r\n        transform:translate(0,0);\r\n    }\r\n\r\n    50%{\r\n        transform:translate(40px,40px);\r\n    }\r\n\r\n}\r\n\r\n/* ==========================\r\n      LOADER\r\n========================== */\r\n\r\n.e2e-loader-spinner{\r\n\r\n    width:120px;\r\n    height:120px;\r\n    position:relative;\r\n    display:flex;\r\n    justify-content:center;\r\n    align-items:center;\r\n\r\n}\r\n\r\n.e2e-loader-spinner::before{\r\n\r\n    content:\"\";\r\n    position:absolute;\r\n    inset:0;\r\n    border-radius:50%;\r\n    padding:5px;\r\n\r\n    background:\r\n    linear-gradient(\r\n        135deg,\r\n        #4285F4,\r\n        #5A9BFF,\r\n        #8E54FF,\r\n        #4285F4\r\n    );\r\n\r\n    -webkit-mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n\r\n    -webkit-mask-composite:xor;\r\n    mask-composite:exclude;\r\n\r\n    animation:rotateRing 1.2s linear infinite;\r\n\r\n}\r\n\r\n@keyframes rotateRing{\r\n\r\n    to{\r\n        transform:rotate(360deg);\r\n    }\r\n\r\n}\r\n\r\n/* Center */\r\n\r\n.circle{\r\n\r\n    width:72px;\r\n    height:72px;\r\n    border-radius:50%;\r\n    background:#fff;\r\n    box-shadow:\r\n        0 10px 30px rgba(66,133,244,.18);\r\n\r\n    display:flex;\r\n    justify-content:center;\r\n    align-items:center;\r\n\r\n    animation:pulseCircle 1.5s infinite;\r\n\r\n}\r\n\r\n.circle::before{\r\n\r\n    content:\"E2E\";\r\n    color:#4285F4;\r\n    font-size:22px;\r\n    font-weight:700;\r\n    letter-spacing:2px;\r\n\r\n}\r\n\r\n@keyframes pulseCircle{\r\n\r\n    0%,100%{\r\n\r\n        transform:scale(1);\r\n\r\n    }\r\n\r\n    50%{\r\n\r\n        transform:scale(.92);\r\n\r\n    }\r\n\r\n}\r\n\r\n/* ==========================\r\n      TEXT\r\n========================== */\r\n\r\n.tfm-loader-text{\r\n\r\n    margin-top:35px;\r\n    font-size:18px;\r\n    color:#325ea8;\r\n    font-weight:600;\r\n    letter-spacing:.4px;\r\n    position:relative;\r\n\r\n}\r\n\r\n.tfm-loader-text::after{\r\n\r\n    content:\"\";\r\n    animation:dots 1.4s infinite;\r\n\r\n}\r\n\r\n@keyframes dots{\r\n\r\n    0%{\r\n        content:\"\";\r\n    }\r\n\r\n    25%{\r\n        content:\".\";\r\n    }\r\n\r\n    50%{\r\n        content:\"..\";\r\n    }\r\n\r\n    75%{\r\n        content:\"...\";\r\n    }\r\n\r\n    100%{\r\n        content:\"\";\r\n    }\r\n\r\n}\r\n\r\n/* ==========================\r\n      FLOATING PARTICLES\r\n========================== */\r\n\r\n.e2e-loader-wrapper span::before,\r\n.e2e-loader-wrapper span::after{\r\n\r\n    content:\"\";\r\n    position:absolute;\r\n    width:10px;\r\n    height:10px;\r\n    border-radius:50%;\r\n    background:#4285F4;\r\n\r\n    animation:particle 3s infinite ease-in-out;\r\n\r\n}\r\n\r\n.e2e-loader-wrapper span::before{\r\n\r\n    left:-70px;\r\n\r\n}\r\n\r\n.e2e-loader-wrapper span::after{\r\n\r\n    right:-70px;\r\n    animation-delay:1.2s;\r\n\r\n}\r\n\r\n@keyframes particle{\r\n\r\n    0%{\r\n\r\n        transform:\r\n        translateY(0)\r\n        scale(.5);\r\n\r\n        opacity:.2;\r\n\r\n    }\r\n\r\n    50%{\r\n\r\n        transform:\r\n        translateY(-30px)\r\n        scale(1);\r\n\r\n        opacity:1;\r\n\r\n    }\r\n\r\n    100%{\r\n\r\n        transform:\r\n        translateY(0)\r\n        scale(.5);\r\n\r\n        opacity:.2;\r\n\r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
